<div id="map">
  <div class="flex wrap justify-content-between bg-white">
    <div class="col-md-auto my-1" *ngIf="displayMapTypeBtns">
      <app-toggle-switch
        [buttonNames]="['NZ Topo', 'Generic', 'Imagery']"
        (selectedNameChange)="onChangeMapType($event)"
      ></app-toggle-switch>
    </div>
    <div class="col-md-auto my-1">
      <app-bird-label-toggle
        *ngIf="hasBirdData()"
        (changesMade)="updateBirdLocations()"
      ></app-bird-label-toggle>
      <div class="form-check" *ngIf="gpsTagData$ | async">
        <label>
          <input type="checkbox" [(ngModel)]="showGpsTagTrack" />
          Show GPS Tag Track
        </label>
      </div>
    </div>
    <div class="col-md-auto my-1">
      <div class="form-inline">
        <ng-container *ngIf="displayIslandSelector && islandList$ | async">
          <select
            class="custom-select"
            id="islandList"
            style="min-width: 136px"
            [compareWith]="byId"
            [ngModel]="selectedIsland$ | async"
            (ngModelChange)="selectIsland($event)"
          >
            <option *ngFor="let opt of islandList$ | async" [ngValue]="opt">
              {{ opt.name }}
            </option>
          </select>
        </ng-container>
        <app-full-screen-toggle [element]="mapNode"></app-full-screen-toggle>
      </div>
    </div>
    <div class="col-md-auto my-1" *ngIf="displayLocationTypeCheckBoxes">
      <div class="form-inline">
        <app-three-state-button
          [labelText]="locationType"
          [state]="getLocationTypeState(locationType)"
          (stateChange)="onLocationTypeStateChange(locationType, $event)"
          *ngFor="let locationType of locationTypes"
        ></app-three-state-button>
      </div>
    </div>
  </div>

  <div class="map-height flex">
    <div id="mapNode" #mapNode></div>
    <div class="bird-legend" *ngIf="hasBirdData()">
      <app-bird-legend
        [birdList]="birdList"
        (birdSelectionChanges)="onBirdSelectionChanges()"
      ></app-bird-legend>
    </div>
  </div>
</div>
